"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_json_view_1 = tslib_1.__importDefault(require("react-json-view"));
const react_use_1 = require("react-use");
const graphql_1 = require("../../../../graphql");
const react_2 = require("@osmosys/react");
const ShowDetailModal = ({ message }) => {
    const [showDebugger, toggleDebugger] = react_use_1.useToggle(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysButton, { osysName: "ShowDetailModal", onClick: () => {
                toggleDebugger(true);
            }, size: "sm", osysStyle: "link", osysIcon: "bracketsCurly" },
            react_1.default.createElement("div", null, "Show data")),
        react_1.default.createElement(react_2.OsmosysModal, { osysName: "MessagesList", isOpen: showDebugger, body: true, toggle: () => {
                toggleDebugger();
            }, className: "p-2", centered: true },
            react_1.default.createElement(react_json_view_1.default, { src: message, collapseStringsAfterLength: 200 }))));
};
exports.MessagesList = () => {
    return (react_1.default.createElement(react_2.OsmosysListLayout, { pathToCount: "messagesCount", pathToItems: "messages", showReloadButton: true, query: {
            query: graphql_1.messages,
        }, itemName: "message", itemsName: "messages", itemProps: msg => {
            return {
                body: (react_1.default.createElement("div", null,
                    react_1.default.createElement(ShowDetailModal, { message: msg }))),
                createdAt: msg.createdAt,
                icon: (react_1.default.createElement(react_2.OsmosysTooltip, { label: msg.subTopic },
                    react_1.default.createElement(react_2.OsmosysIcon, { size: "4x", osysIcon: msg.subTopic === 'hostedFile'
                            ? 'hostedFile'
                            : msg.subTopic === 'workspace'
                                ? 'workspace'
                                : msg.subTopic === 'currentUser'
                                    ? 'user'
                                    : 'message' }))),
                title: msg.message,
            };
        } }));
};
exports.default = exports.MessagesList;
//# sourceMappingURL=MessagesList.js.map